// src/store/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarOpen: false,
  demoModalOpen: false,
  loading: {}
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  
  reducers: {
    openSidebar: (s) => { s.sidebarOpen = true; },
    closeSidebar: (s) => { s.sidebarOpen = false; },
    toggleSidebar: (s) => { s.sidebarOpen = !s.sidebarOpen; },
    openDemoModal: (s) => { s.demoModalOpen = true; },
    closeDemoModal: (s) => { s.demoModalOpen = false; },

    // message-aware start/stop
    startLoading: (s, { payload }) => {
      const { key, message } =
        typeof payload === 'string' ? { key: payload, message: null } : payload;

      const prev = s.loading[key];
      s.loading[key] = {
        count: (prev?.count ?? 0) + 1,
        message: message ?? prev?.message ?? null,
      };
    },
    stopLoading: (s, { payload: key }) => {
      const entry = s.loading[key];
      if (!entry) return;
      const next = Math.max(0, entry.count - 1);
      if (next === 0) {
        delete s.loading[key];
      } else {
        entry.count = next;
      }
    },
    resetAllLoading: (s) => { s.loading = {}; },
  },
});

export const {
  openSidebar, closeSidebar, toggleSidebar,   openDemoModal, closeDemoModal,
  startLoading, stopLoading, resetAllLoading
} = uiSlice.actions;

export default uiSlice.reducer;

// ---- selectors ----
export const selectSidebarOpen = (state) => state.ui.sidebarOpen;
export const selectIsLoading = (key) => (state) => (state.ui.loading[key]?.count ?? 0) > 0;
export const selectLoadingMessage = (key) => (state) => state.ui.loading[key]?.message || null;
export const selectAnyLoading = (state) =>
  Object.values(state.ui.loading).some(e => (e?.count ?? 0) > 0);
  export const selectDemoModalOpen = (state) => state.ui.demoModalOpen;